// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottom_affix":"bottom_affix-oVaIWrmM","backToTop":"backToTop-19Jx3sHa"};